import createReactClass from "create-react-class";
import React from "react";
import { InformationRadiatorRowView } from "../components/informationRadiatorRow";
import { informationRadiatorStore } from "../stores/informationRadiator";
import { restrictionRequestStore } from "../stores/restrictionRequest";
import { schematicStore } from "../stores/schematic";

//function to get state from store, getting the currently loaded formb
function getStateFromStores() {
  return {
    messages: informationRadiatorStore.getMessages(),
  };
}

export const InformationRadiatorView = createReactClass({
  componentDidMount: function () {
    informationRadiatorStore.subscribe(this._onChange);
    restrictionRequestStore.subscribe(this._onChange);
    schematicStore.subscribe(this._onChange);
  },

  componentWillUnmount: function () {
    informationRadiatorStore.unsubscribe(this._onChange);
    restrictionRequestStore.unsubscribe(this._onChange);
    schematicStore.unsubscribe(this._onChange);
  },

  getInitialState: function () {
    return getStateFromStores();
  },

  _onChange: function () {
    this.setState(getStateFromStores());
  },

  //modify this to return the formBform view markup
  render: function () {
    var messages = this.state.messages;

    var rows = "";
    if (messages) {
      rows = messages.map(function (message, i) {
        return <InformationRadiatorRowView key={i} message={message} />;
      });
    }

    var showHideStyle;
    var type;
    if (messages && messages.length > 0) {
      showHideStyle = "";
      type = messages[0].type;
    } else {
      showHideStyle = "none";
      type = "";
    }

    switch (type) {
      case "info":
        var infoRadiatorTitle = "Success:";
        var infoTitleClass = "infoRadiatorTitleInfo";
        break;
      case "warning":
        var infoRadiatorTitle = "The following warnings were found:";
        var infoTitleClass = "infoRadiatorTitleWarning"; //or infoRadiatorTitleInfo
        break;
      default:
        //assume error I guess
        var infoRadiatorTitle = "The following errors were found:";
        var infoTitleClass = "infoRadiatorTitleError"; //or infoRadiatorTitleInfo
    }

    //build up the form and bind the values
    return (
      <div style={{ display: showHideStyle }}>
        <div className={infoTitleClass}>{infoRadiatorTitle}</div>
        <div id="informationRadiatorInnerDiv">
          <ul id="informationRadiatorInnerUl">{rows}</ul>
        </div>
      </div>
    );
  },
});
